import { useQuery, useMutation } from 'react-query'
import API from '.'
import { serializeQuery } from './utils'

const ENDPOINT = '/api/staff-benefit'
const QUERY_KEY = 'staff-benefit'

export const useGetStaffBenefits = (query = {}, config = { refetchOnWindowFocus: false }) =>
  useQuery(
    [QUERY_KEY, 'list', query],
    async () => (await API.get(serializeQuery(ENDPOINT, query))).data,
    config
  )

export const usePostStaffBenefit = (config = {}) =>
  useMutation((newData) => API.post(ENDPOINT, newData), config)

export const useApplyStaffBenefit = (config = {}) =>
  useMutation((data) => API.post(`${ENDPOINT}/apply`, data), config)

export const usePatchStaffBenefit = (config = {}) =>
  useMutation((updatedData) => API.patch(`${ENDPOINT}`, updatedData), config)

export const useDeleteStaffBenefit = (config = {}) =>
  useMutation((id) => API.delete(`${ENDPOINT}`, { data: id }), config)
